import React, { useState, useEffect } from 'react';
import { Result, Button, Typography, Space, Collapse, message } from 'antd';
import { ArrowLeftOutlined, ClearOutlined, CopyOutlined, CheckOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { getCurrentUserRole } from 'modules/utilities/utility';
import secureLocalStorage from 'react-secure-storage';

const { Text, Paragraph } = Typography;

const Error404 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [copied, setCopied] = useState(false);

  const errorInfo = {
    path: location.state?.attemptedPath || location.pathname,
    timestamp: new Date().toISOString(),
    role: getCurrentUserRole(),
    email: secureLocalStorage.getItem('email') || 'unknown',
  };

  useEffect(() => {
    console.warn('[Error404] Page not found', errorInfo);
  }, []);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleClearStorage = () => {
    localStorage.clear();
    sessionStorage.clear();
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    }
    navigate('/login');
  };

  const handleCopy = () => {
    const text = Object.entries(errorInfo)
      .map(([k, v]) => `${k}: ${v}`)
      .join('\n');
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(() => {
        setCopied(true);
        message.success('Error details copied');
        setTimeout(() => setCopied(false), 2000);
      });
    } else {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      setCopied(true);
      message.success('Error details copied');
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const detailItems = [
    {
      key: '1',
      label: <Text type="secondary" style={{ fontSize: 13 }}>Error Details</Text>,
      children: (
        <div>
          <div style={{
            background: '#f5f5f5',
            borderRadius: 8,
            padding: '12px 16px',
            fontFamily: 'monospace',
            fontSize: 13,
            lineHeight: 1.8,
            marginBottom: 12,
          }}>
            {Object.entries(errorInfo).map(([k, v]) => (
              <div key={k}>
                <Text type="secondary">{k}:</Text>{' '}
                <Text strong>{v}</Text>
              </div>
            ))}
          </div>
          <Button
            size="small"
            icon={copied ? <CheckOutlined /> : <CopyOutlined />}
            onClick={handleCopy}
          >
            {copied ? 'Copied!' : 'Copy Details'}
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '80vh',
      padding: 24,
    }}>
      <Result
        status="404"
        title="404"
        subTitle="The page you're looking for doesn't exist or has been moved."
        style={{ maxWidth: 560 }}
        extra={
          <div>
            <Space wrap style={{ marginBottom: 24 }}>
              <Button icon={<ArrowLeftOutlined />} onClick={handleGoBack}>
                Go Back
              </Button>
              <Button type="primary" icon={<ClearOutlined />} onClick={handleClearStorage}>
                Clear Cache & Login
              </Button>
            </Space>
            <Paragraph type="secondary" style={{ fontSize: 13, marginBottom: 16 }}>
              If you think this is a mistake,{' '}
              <a href="mailto:sultantippu@traya.health">contact support</a>.
            </Paragraph>
            <Collapse
              ghost
              items={detailItems}
              style={{ textAlign: 'left' }}
            />
          </div>
        }
      />
    </div>
  );
};

export default Error404;
